import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'morva-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
})
export class DeleteDialogComponent implements OnInit {
  asset: any;

  constructor(protected dialogRef: NbDialogRef<any>) { }

  ngOnInit(): void {
    this.getAsset();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onDeleteClick() {
    this.dialogRef.close(this.asset);
  }

  getAsset() {
    this.asset = this.dialogRef.componentRef.instance;
  }


}
